import { Box, LinearProgress, Typography } from "@mui/material";
import { formatNumber } from "./utils";

type Props = {
	actualTons: number | null;
	targetTons: number | null;
};

export const MonthlyProgressBar = ({ actualTons, targetTons }: Props) => {
	const actual = actualTons ?? 0;
	const target = targetTons ?? 0;
	const pct = target > 0 ? (actual / target) * 100 : 0;
	const clamped = Math.min(100, Math.max(0, pct));

	return (
		<Box sx={{ mt: 1 }}>
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "baseline",
					mb: 0.5,
				}}
			>
				<Typography sx={{ fontSize: "0.72rem", color: "#777" }}>
					{formatNumber(actual, 0)} / {formatNumber(target, 0)} t
				</Typography>
				<Typography
					sx={{ fontSize: "0.72rem", fontWeight: 600, color: "#333" }}
				>
					{pct.toFixed(1)}%
				</Typography>
			</Box>
			<LinearProgress
				variant="determinate"
				value={clamped}
				sx={{
					height: 8,
					borderRadius: 1,
					backgroundColor: "#f0f0f0",
					"& .MuiLinearProgress-bar": {
						backgroundColor: (theme) => theme.palette.primary.main,
						borderRadius: 1,
					},
				}}
			/>
		</Box>
	);
};
